import {Map} from 'immutable';
import {omit} from 'ramda';

const mapParams = Map({
  hotel_config : Map(),
  engine_config : Map(/* {
    config: Map({
      prices_active: false,
      engine_active: true,
    })
  } */)
});

export const contextualizeAppConfig = (store, hotelId, keyConfig = 'hotel_config') => {

  let hotelConfig;
  if(!hotelId) {
    hotelConfig = Map();
  } else {
    hotelConfig = store.getIn(['app', 'hotelConfig', hotelId], Map()).merge(store.getIn(['hotels', hotelId, keyConfig], Map()))
  }

  const appConfig = store.getIn(['app', 'config'],  mapParams.get(keyConfig, Map()));
  let config = appConfig.merge(hotelConfig);

  const deviceType = store.getIn(['system', 'device'])
  if(deviceType && deviceType !== 'desktop') {
    const base = config.deleteAll(['mobile', 'tablet']);
    const device = config.get(deviceType, null)
    if(device) {
      config = base.merge(device);
    }
  }
  return config;
};


export const enableCachePrices = (store) => {
  const params = store.getIn(["customer", "params", "avail_cache_params"], Map());
  const config =  contextualizeAppConfig(store, params.get("hotelId"), "engine_config");
  return !!(store.getIn(["customer", "current_currency"]) && config.get("prices_active"));
};




//www.hotelinfantasdeleon.com   no apareix motor
//www.oncinaebygescaho.com  no apareix motor
//www.hoteleuropajaen.es   no apareix motor


